export default {
  groupName: 'ford-ca-lincoln',
  appName: 'Lincoln Canada',
  isAuto: true,
  image: 'ford_lincoln.png',
  baseRoute: '/ford-ca-lincoln',
  description:
  'Lincoln - Canada Luxury Advertising Dashboard (Starting Apr 2019)'
}
